<template>
  <div class="pdf-template" ref="pdfContent">
    <!-- Header Section -->
    <div class="pdf-header">
      <div class="header-content">
        <div class="logo-section">
          <img
              :src="this.companyIcon"
              alt="Logo"
              class="logo"
          />
        </div>
        <div class="title-section">
          <h1 class="main-title">{{ reportTitle }}</h1>
          <p class="date-range">{{createdDate}}</p>
        </div>
      </div>
    </div>

    <!-- Report Description -->
    <div class="report-description" v-if="reportDescription">
      <h2>Rapor Açıklaması</h2>
      <p>{{ reportDescription }}</p>
    </div>

    <!-- Charts Grid - 2x2 Layout -->
    <div class="charts-grid">
      <div
        v-for="(chart, index) in charts.slice(0, 4)"
        :key="index"
        class="chart-item"
      >
        <div class="chart-header">
          <div class="chart-title-section">
            <h3 class="chart-title">{{ chart.title }}</h3>
            <p class="chart-date-range">{{ dateRange }}</p>
          </div>
        </div>
        <div class="chart-content">
          <!-- Canvas element buraya programatically eklenecek -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ibilityLogo from "@/assets/images/iblity_black.svg";

export default {
  name: 'PDFTemplate',
  data() {
    return {
      companyIcon : localStorage.getItem('logoCacheUrl') || ibilityLogo,
      createdDate: new Date().toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }),
      isPdfGenerating: false
    }
  },
  props: {
    reportTitle: {
      type: String,
      default: 'Rapor'
    },
    dateRange: {
      type: String,
      default: ''
    },
    charts: {
      type: Array,
      default: () => []
    },
    reportDescription: {
      type: String,
      default: ''
    }
  },
  mounted() {
   console.log('gelen charts : ', this.charts);
    const companyIcon = localStorage.getItem('logoCacheUrl')

   console.log('user üzerinden gelen icon : ', companyIcon);

    this.charts.forEach((chart, index) => {
      console.log(`Chart ${index}:`, {
        title: chart.title,
        hasTitle: !!chart.title,
        chartKeys: Object.keys(chart)
      });
    });
  },
  computed: {
    generatedDate() {
      return new Date().toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  methods: {
    async generateCurrentChartsPDF() {
      this.isPdfGenerating = true; // Spinner başlat

      try {
        // PDF oluşturma işlemi...
      } finally {
        this.isPdfGenerating = false; // Spinner durdur
      }
    }
  }
}
</script>

<style scoped>
.pdf-template {
  width: 210mm;
  max-height: 280mm;
  height: auto;
  background: white;
  font-family: 'Inter', 'Arial', sans-serif;
  color: #1D2939;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.pdf-header {
  background: white;
  border-bottom: 1px solid #EAECF0;
  margin: 5px 10px;
  padding-bottom: 8px;
}

.header-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
  width: 100% !important;
}

.logo-section {
  display: flex;
  align-items: center;
}

.title-section {
  text-align: center;
  flex: 1;
}

.main-title {
  font-size: 20px;
  font-weight: 600;
  color: #101828;
  line-height: 100%;
}

.date-range {
  font-size: 11px;
  color: #667085;
  font-weight: 500;
  line-height: 100%;
  margin-top: 8px;
}

/* Report Description */
.report-description {
  padding: 8px 15px 12px 15px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
  margin-bottom: 8px;
}

.report-description h2 {
  color: #101828;
  font-size: 14px;
  font-weight: 600;
  font-family: euclid_medium, sans-serif;
  margin: 0;
}

.report-description p {
  font-size: 9px;
  font-weight: 400;
  color: #667085;
  line-height: 1.4;
  margin: 0;
  text-align: justify;
  white-space: pre-line;
}

/* Charts Grid - 2x2 Layout */
.charts-grid {
  padding: 3px 15px 8px 15px;
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 6px;
  height: auto;
  min-height: auto;
  align-items: start;
}

.chart-item {
  page-break-inside: avoid;
  box-sizing: border-box;
  border: 1px solid #EAECF0;
  border-radius: 8px;
  justify-content: flex-start;
  align-items: center;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: auto;
  max-height: none;
}

.chart-header {
  display: flex;
  align-items: flex-start;
  padding: 8px;
  font-family: euclid_regular, sans-serif;
  justify-content: flex-start;
  width: 100%;
  flex-shrink: 0;
}

.chart-title-section {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  text-align: left;
  align-items: flex-start;
}

.chart-title {
  font-size: 11px;
  font-weight: 500;
  color: #475467;
  line-height: 100%;
  font-family: euclid_regular, sans-serif;
  margin: 0;
  text-align: left;
}

.chart-date-range {
  font-size: 7px;
  font-weight: 400;
  color: #9CA3AF;
  line-height: 100%;
  font-family: euclid_regular, sans-serif;
  margin: 0;
  text-align: left;
}

.chart-content {
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 4px);
  height: auto;
  min-height: 200px;
  background: white;
  flex: 0 0 auto;
  overflow: visible;
}

.logo {
  height: 40px;
  width: auto;
}

/* Print Styles */
@media print {
  .pdf-template {
    width: 100%;
    height: 100%;
  }

  .chart-item {
    page-break-inside: avoid;
  }

  .charts-grid {
    page-break-inside: avoid;
  }
}
</style>
